import { render, staticRenderFns } from "./BackpackEmpty.vue?vue&type=template&id=2fdb2134&scoped=true"
import script from "./BackpackEmpty.vue?vue&type=script&lang=js"
export * from "./BackpackEmpty.vue?vue&type=script&lang=js"
import style0 from "./BackpackEmpty.vue?vue&type=style&index=0&id=2fdb2134&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdb2134",
  null
  
)

export default component.exports